<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <aru-search-entity
          v-if="configReady"
          :with-progress-bar="true"
          :page="page"
          :search-config="config.search"
          :entity="entity"
          v-model="items"
          @loading="
            page = 1;
            itemsReady = false;
          "
          @stopLoading="itemsReady = true"
          @meta="setPagination"
        ></aru-search-entity>
      </v-flex>
    </v-layout>

    <div class="v-table__overflow">
      <table class="v-datatable v-table theme--light">
        <thead>
          <tr>
            <th v-for="(field, i) in header" :key="i" :class="getThClass(field)">
              <template v-if="field.value">
                <v-btn
                  class="v-btn-header-datatable"
                  :class="getBtnClass(field)"
                  :color="getOrderThColor(field.value)"
                  flat
                  small
                  @click="orderBy(field.value)"
                >
                  {{ $t(field.text) }}
                  <v-icon>{{ getOrderChevronIcon(field.value) }}</v-icon>
                </v-btn>
              </template>

              <template v-else>
                <v-btn
                  class="v-btn-header-datatable"
                  :class="getBtnClass(field)"
                  disabled
                  :color="getOrderThColor('other')"
                  flat
                  small
                >
                  {{ $t(field.text) }}
                </v-btn>
              </template>
            </th>
          </tr>
        </thead>
        <tbody v-if="readyToList">
          <tr v-for="(entity, i) in items" :key="entity.id">
            <td>{{ entity.cif }}</td>
            <td>{{ entity.name | truncate(30, '...') }}</td>
            <td>{{ entity.username | truncate(20, '...') }}</td>
            <!-- <td>{{entity.updated_at | moment("DD/MM/YYYY")}}</td>
            <td>{{entity.created_at | moment("DD/MM/YYYY")}}</td> -->
            <td>{{ entity.expiration_date | moment('DD/MM/YYYY') }}</td>
            <td>
              <span :class="getStatusColor(entity.status) + '--text'">
                <v-icon :color="getStatusColor(entity.status)">
                  {{ getStatusIcon(entity.status) }}
                </v-icon>
                {{ $t(entity.status) }}
              </span>

              <!-- <v-menu offset-y>
                  <v-btn small slot="activator" :color="getStatusColor(entity.status)" flat>
                    <v-icon>{{getStatusIcon(entity.status)}}</v-icon> {{$t(entity.status)}} <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile @click="validateEntity(entity, i)">
                      <v-list-tile-title class="primary--text">
                        <v-icon class="primary--text">mdi-check-outline</v-icon> {{$t('Validar')}}
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeStatus(entity, 'cancelled', i)">
                      <v-list-tile-title class="error--text">
                        <v-icon class="error--text">mdi-close-outline</v-icon> {{$t('Cancelar')}}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile @click="changeStatus(entity, 'draft', i)">
                      <v-list-tile-title class="grey--text">
                        <v-icon class="grey--text">mdi-file-hidden</v-icon> {{$t('Borrador')}}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile @click="changeStatus(entity, 'generated-pdf', i)">
                      <v-list-tile-title class="grey--text">
                        <v-icon class="grey--text">mdi-file-pdf-outline</v-icon> {{$t('PDF generado')}}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu> -->
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-chip
                    v-on="on"
                    class="px-0"
                    outline
                    :color="getChecklistColor(entity)"
                    small
                    :text-color="getChecklistColor(entity)"
                  >
                    {{ checklistCompletedPercent(entity)['completed'] }}/{{
                      checklistCompletedPercent(entity)['total']
                    }}
                  </v-chip>
                </template>
                <span>{{ $t('Medidas comprobadas / Medidas totales recomendadas') }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right">
              <v-menu offset-y>
                <v-btn
                  :disabled="loadingEntity[entity.id]"
                  slot="activator"
                  color="primary"
                  dark
                  flat
                  min-width="100"
                >
                  <template v-if="!loadingEntity[entity.id]">
                    {{ $t('Acciones') }}
                  </template>
                  <v-progress-circular
                    v-if="loadingEntity[entity.id]"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-btn>
                <v-list>
                  <v-list-tile @click="showLopdDataDialog(entity)">
                    <v-list-tile-title>
                      <v-icon>mdi-eye-outline</v-icon>
                      {{ $t('Ver formulario') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :disabled="loadingAnyEntity" @click="generatePDF(entity, i)">
                    <v-list-tile-title>
                      <v-icon>mdi-file-pdf-outline</v-icon>
                      {{ $t('(Re)generar PDF') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="entity.media[0]" @click="downloadPDF(entity)">
                    <v-list-tile-title>
                      <v-icon>mdi-file-download-outline</v-icon>
                      {{ $t('Descargar PDF') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="changeStatus(entity, 'draft', i)">
                    <v-list-tile-title>
                      <v-icon>mdi-file-hidden</v-icon>
                      {{ $t('Marcar como borrador') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="showDateModal(entity, i)">
                    <v-list-tile-title>
                      <v-icon>mdi-calendar-edit</v-icon>
                      {{ $t('Editar fecha de validez') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="validateEntity(entity, i)">
                    <v-list-tile-title class="primary--text">
                      <v-icon class="primary--text">mdi-check-outline</v-icon>
                      {{ $t('Validar') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="changeStatus(entity, 'cancelled', i)">
                    <v-list-tile-title class="error--text">
                      <v-icon class="error--text">mdi-close-outline</v-icon>
                      {{ $t('Cancelar') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="deleteEntity(entity, i)">
                    <v-list-tile-title class="error--text">
                      <v-icon class="error--text">mdi-trash-can-outline</v-icon>
                      {{ $t('Eliminar') }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="i in 15" :key="'mock-table' + i">
            <td v-for="(field, i) in header" :key="i">
              <div class="grey lighten-3" :style="getMockStyle(field)"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-xs-center" v-if="showPagination">
        <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
      </div>
    </div>

    <v-dialog v-model="showLopdData" fullscreen>
      <lopd-data-view
        v-if="selectedEntity"
        :entity="selectedEntity"
        @close="showLopdData = false"
      ></lopd-data-view>
    </v-dialog>

    <v-dialog v-model="dateModal" width="500">
      <template v-if="selectedEntity">
        <aru-auto-form
          v-if="!!config"
          v-model="selectedEntity"
          :validate-before-submit="true"
          :key="selectedEntity.id"
          :form-configuration="config.expirationDateForm"
          dismiss-button
          :dismiss-text="$t('Cancelar')"
          @dismiss="dateModal = false"
          @submit="changeExpirationDate(selectedEntity, selectedIndex)"
        ></aru-auto-form>
      </template>
      <!-- <lopd-data-view  :entity="selectedEntity" @close="showLopdData = false"></lopd-data-view> -->
    </v-dialog>
  </div>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';
import AruListMixin from '@/mixins/list/AruListMixin.js';
import AruSearchEntity from '@/components/commons/search/AruSearchEntity';
import LopdDataView from './LopdDataView';
import AruAutoForm from '@/components/commons/form/AruAutoForm.vue';

export default {
  mixins: [AruListMixin],
  components: {
    AruSearchEntity,
    LopdDataView,
    AruAutoForm,
  },
  props: {
    adminActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showLopdData: false,
      dateModal: false,
      selectedEntity: null,
      selectedIndex: null,
      loadingEntity: {},
      loadingAnyEntity: false,
      header: [
        {
          value: 'cif',
          text: 'CIF/NIF',
          mockWidth: '50px',
        },
        {
          value: 'name',
          text: 'Empresa',
          mockWidth: '150px',
        },
        {
          value: 'username',
          text: 'Usuario',
          mockWidth: '100px',
        },
        // {
        //   value: "updated_at",
        //   text: "Actualizado"
        // },
        // {
        //   value: "created_at",
        //   text: "Creado"
        // },
        {
          value: 'expiration_date',
          text: 'Validez',
        },
        {
          value: 'status',
          text: 'Estado',
        },
        {
          value: '',
          text: 'Medidas',
        },
        {
          value: '',
          text: 'Acciones',
          btnClass: 'pr-4',
          thClass: 'text-xs-right py-0',
          mockAlign: 'right',
        },
      ],
    };
  },
  methods: {
    getChecklistColor(opendataForm) {
      if (this.checklistStatus(opendataForm) === 'completed') {
        return 'primary';
      } else {
        return 'secondary';
      }
    },
    checklistCompletedPercent(opendataForm) {
      let total = 17;
      let completed = 0;
      if (!!opendataForm && opendataForm.hasOwnProperty('checklist') && !!opendataForm.checklist) {
        total = 0;
        completed = 0;
        for (const key in opendataForm.checklist) {
          if (opendataForm.checklist.hasOwnProperty(key)) {
            const value = opendataForm.checklist[key];
            total++;
            if (value) {
              completed++;
            }
          }
        }
      }
      return { total: total, completed: completed };
    },
    checklistStatus(opendataForm) {
      if (!!opendataForm && opendataForm.hasOwnProperty('checklist') && !!opendataForm.checklist) {
        for (const key in opendataForm.checklist) {
          if (opendataForm.checklist.hasOwnProperty(key)) {
            const value = opendataForm.checklist[key];
            if (!value) {
              return 'uncompleted';
            }
          }
        }
        return 'completed';
      } else {
        return 'uncompleted';
      }
    },
    getChecklistIcon(opendataForm) {
      if (this.checklistStatus(opendataForm) === 'completed') {
        return 'mdi-clipboard-check-outline';
      } else {
        return 'mdi-clipboard-text-play-outline';
      }
    },

    getThClass(field) {
      if (field.hasOwnProperty('thClass')) {
        return field.thClass;
      } else {
        return 'text-xs-left py-0';
      }
    },

    getBtnClass(field) {
      if (field.hasOwnProperty('btnClass')) {
        return field.btnClass;
      } else {
        return '';
      }
    },

    showDateModal(entity, i) {
      this.selectedEntity = entity;
      this.selectedIndex = i;
      this.dateModal = true;
    },

    getMockStyle(field) {
      const style = {
        width: field.mockWidth ? field.mockWidth : '80px',
        height: field.mockHeight ? field.mockHeight : '15px',
        'border-radius': field.mockRadius ? field.mockRadius : '10px',
        float: field.mockAlign ? field.mockAlign : 'none',
      };
      return style;
    },
    orderBy(field) {
      if (
        this.params.hasOwnProperty('orderBy') &&
        this.params.orderBy === field &&
        this.params.hasOwnProperty('sortedBy')
      ) {
        if (this.params.sortedBy === 'desc') {
          this.$set(this.params, 'orderBy', field);
          this.$set(this.params, 'sortedBy', 'asc');
        } else {
          delete this.params.orderBy;
          delete this.params.sortedBy;
        }
      } else {
        this.$set(this.params, 'orderBy', field);
        this.$set(this.params, 'sortedBy', 'desc');
      }

      this.getEntities();
    },

    deleteEntity(entity, i) {
      console.log({
        DELETE: entity,
      });

      apiCtrl.delete('/' + this.entity + '/' + entity.id).then(res => {
        this.$delete(this.items, i);
      });
    },

    getOrderThColor(field) {
      if (this.params.hasOwnProperty('orderBy') && this.params.orderBy === field) {
        return 'primary';
      } else {
        return 'grey';
      }
    },
    getOrderChevronIcon(field) {
      if (
        this.params.hasOwnProperty('orderBy') &&
        this.params.orderBy === field &&
        this.params.hasOwnProperty('sortedBy')
      ) {
        if (this.params.sortedBy === 'asc') {
          return 'mdi-chevron-up';
        } else if (this.params.sortedBy === 'desc') {
          return 'mdi-chevron-down';
        }
      }

      return 'mdi-chevron-right';
    },
    getStatusColor(status) {
      switch (status) {
        case 'validated':
          return 'primary';
        case 'cancelled':
          return 'error';

        default:
          return 'grey';
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case 'validated':
          return 'mdi-check-outline';
        case 'cancelled':
          return 'mdi-close-outline';
        case 'draft':
          return 'mdi-file-hidden';
        case 'generated-pdf':
          return 'mdi-file-pdf-outline';
        default:
          return 'mdi-clock-outline';
      }
    },
    showLopdDataDialog(entity) {
      this.selectedEntity = entity;
      this.showLopdData = true;
    },
    downloadEntity(entity) {
      console.log(entity);
      if (entity.hasOwnProperty('media') && entity.media.length > 0) {
        apiCtrl
          .get('/document/download/' + entity.media[0].id)
          .then(res => {
            apiCtrl.downloadFile(res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    generatePDF(entity, i) {
      this.$set(this.loadingEntity, entity.id, true);
      this.loadingAnyEntity = true;
      apiCtrl
        .post('/opendata-form/generate-pdf/', entity)
        .then(res => {
          //   this.$router.push("/opendata/form/wellcome");
          this.$set(this.loadingEntity, entity.id, false);
          this.loadingAnyEntity = false;
          this.$set(this.items, i, res.data.data);
          // this.getEntities();
        })
        .catch(() => {
          this.$set(this.loadingEntity, entity.id, false);
          this.loadingAnyEntity = false;
          // this.savingData = false;
        });
    },
    downloadPDF(entity) {
      this.downloadEntity(entity);
    },

    changeStatus(entity, status, i) {
      if (entity.status !== status) {
        entity.status = status;

        apiCtrl
          .put('/opendata-form/' + entity.id, entity)
          .then(res => {
            // entity = res.data.data;
            //   this.$router.push("/opendata/form/wellcome");
            // this.getEntities();

            this.$set(this.items, i, res.data.data);
          })
          .catch(err => {
            this.savingData = false;
          });
      }
    },

    changeExpirationDate(entity, i) {
      this.$set(this.loadingEntity, entity.id, true);
      this.dateModal = false;
      apiCtrl
        .put('/opendata-form/' + entity.id, entity)
        .then(res => {
          // entity = res.data.data;
          //   this.$router.push("/opendata/form/wellcome");
          // this.getEntities();

          this.$set(this.items, i, res.data.data);
          this.$set(this.loadingEntity, entity.id, false);
        })
        .catch(err => {
          this.$set(this.loadingEntity, entity.id, false);
        });
    },
    validateEntity(entity, i) {
      if (entity.status !== 'validated') {
        entity.status = 'validated';
        delete entity.expiration_date;

        apiCtrl
          .put('/opendata-form/' + entity.id, entity)
          .then(res => {
            // entity = res.data.data;
            //   this.$router.push("/opendata/form/wellcome");
            // this.getEntities();
            this.$set(this.items, i, res.data.data);
          })
          .catch(err => {
            this.savingData = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
.v-btn-header-datatable {
  min-width: 0px;
  margin: 0px;
  padding: 0px;
}
</style>
